namespace SPA
{
	export namespace Realtor
	{

		class BandwidthSign
			extends ui.base.BaseHTMLElement
		{

			public constructor( text: JQuery )
			{
				super( 'sign' );

				this.html( text );
			}

		}

		export class EnergyCertificateVisual
			extends ui.base.HTMLPresentation
		{

			private	m_OverallEfficiency:	number|null;
			private	m_PrimaryConsumption:	number|null;
			private	m_BandwidthLength:		number;
			private	m_Step:								number;

			public constructor( oe: number|null, pc: number|null, length: number, step: number, type: string = '' )
			{
				super( 'energycertificate' );

				this.addClass( type );

				this.m_OverallEfficiency	= oe;
				this.m_PrimaryConsumption	= pc;
				this.m_BandwidthLength		= length;
				this.m_Step								= step;
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): EnergyCertificateVisual
			{
				super.rebuild( root );

				this.empty();

				const bw = new ui.base.BaseHTMLElement( 'bandwidth' ).appendTo( this );

				for ( let i = 0; i <= this.m_BandwidthLength; i += this.m_Step )
				{
					const n: JQuery = this.AddTransparentZeros( i );
					new BandwidthSign( i === this.m_BandwidthLength ? n.prepend( ui.$$.span().text( '>' ) ) : n ).appendTo( bw );
				}

				if ( typeof this.m_OverallEfficiency === 'number' )
				{
					this.append(
						$( document.createElement( 'marker' ) ).css(
							{
								left:	'calc( ' + clamp( this.m_OverallEfficiency / ( this.m_BandwidthLength / 100 ), 0, 99 ) + '% )'
							}
						)
					);
				}

				if ( typeof this.m_PrimaryConsumption === 'number' )
				{
					this.append(
						$( document.createElement( 'marker' ) ).css(
							{
								left:	'calc( ' + clamp( this.m_PrimaryConsumption / ( this.m_BandwidthLength / 100 ), 0, 99 ) + '% )'
							}
						)
					);
				}

				return this;
			}

			private AddTransparentZeros( n: number ): JQuery
			{
				if ( n < 10 )
				{
					return ui.$$.span()
						.append( ui.$$.span().text( n ) )
						.append( ui.$$.span().text( '000' ).css( 'color', 'transparent' ) );
				}
				else if ( n < 100 )
				{
					return ui.$$.span()
						.append( ui.$$.span().text( n ) )
						.append( ui.$$.span().text( '00' ).css( 'color', 'transparent' ) );
				}
				else if ( n < this.m_BandwidthLength )
				{
					return ui.$$.span()
						.append( ui.$$.span().text( '0' ).css( 'color', 'transparent' ) )
						.append( ui.$$.span().text( n ) );
				}
				else
				{
					return ui.$$.span().append( ui.$$.span().text( n ) );
				}
			}

		}

	}
}
